import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// COMPONENTS

// MODULES
import { NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';

import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';
import { FilterModule } from '../filter/filter.module';
import { PipeModule } from '../shared/pipes/pipe.module';
import { UiModule } from '../ui/ui.module';

import { DirectiveModule } from './../shared/directives/directive.module';
import {
  PicklistItemTableComponent,
  PicklistItemsComponent,
  PicklistItemFiltersComponent,
  PicklistItemStatusComponent,
  PicklistItemLocationBreakdownComponent,
  PicklistItemDetailsComponent,
  PicklistPreviewTableComponent,
  PicklistPreviewDialogComponent,
  PicklistPackingComponent,
  PicklistPackingTableComponent,
  PicklistPackingHoldOrderPopupComponent,
  PicklistPackingHoldOrderPopupSuccessComponent,
  PicklistPackingTableDetailsComponent,
  PicklistPackingTableActionsComponent,
  PicklistVerifyComponent,
  PicklistAddOrderFormComponent,
  PicklistVirtualCalculatorFormComponent,
  PicklistKitsComponent,
  PackingSlipConfigDialogComponent,
} from './components';

// PIPES
import {
  PicklistItemClassPipe,
  PicklistLocationTotalQuantityPipe,
  PicklistItemSortPipe,
} from './pipes';

const components = [
  PicklistItemTableComponent,
  PicklistItemsComponent,
  PicklistItemFiltersComponent,
  PicklistItemStatusComponent,
  PicklistItemLocationBreakdownComponent,
  PicklistItemDetailsComponent,
  PicklistPreviewTableComponent,
  PicklistPreviewDialogComponent,
  PicklistPackingComponent,
  PicklistPackingTableComponent,
  PicklistPackingHoldOrderPopupComponent,
  PicklistPackingHoldOrderPopupSuccessComponent,
  PicklistPackingTableDetailsComponent,
  PicklistPackingTableActionsComponent,
  PicklistVerifyComponent,
  PicklistAddOrderFormComponent,
  PicklistVirtualCalculatorFormComponent,
  PicklistKitsComponent,
  PackingSlipConfigDialogComponent,
];

const angularModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  NgxScannerQrcodeModule,
];
const lumModules = [
  SharedComponentsModule,
  PipeModule,
  DirectiveModule,
  MaterialCustomModule,
  UiModule,
  FilterModule,
];
const pipes = [
  PicklistItemClassPipe,
  PicklistLocationTotalQuantityPipe,
  PicklistItemSortPipe,
];
@NgModule({
  declarations: [...components, ...pipes],
  imports: [...angularModules, ...lumModules],
  exports: [...components],
  schemas: [NO_ERRORS_SCHEMA],
})
export class PicklistModule {}
